import browser from '../../../bindings/isMobile-browser';

const minZindex = 100;

export const VIDEO_WINDOW_UNMOVED_CLASS = 'unmoved-left';
export const VIDEO_WINDOW_UNTOUCHED_CLASS = 'untouched-left';

var windows = [];

export function register(window, uid, draggie) {
    window.addEventListener('click', onClickGeneric);
    window.addEventListener('mousedown', onClickGeneric);
    windows.push(window);

    reorderVirtualWindows(window);
    positionNewVirtualWindow(window, uid);

    if (draggie) {
        draggie.on('dragStart', function(e, p) { onDragStart(e, p, window) })
    }
}

export function unregister(window) {
    window.removeEventListener('click', onClickGeneric);

    var newWindows = [];

    for (var index in windows) {
        if (windows[index] !== window) {
            newWindows.push(windows[index]);
        }
    }

    windows = newWindows;

    var topVirtualWindow = getTopVirtualWindow();
    reorderVirtualWindows(topVirtualWindow);
}

export function reorderVirtualWindows(window) {
    if (window.className.indexOf('fullscreen') !== -1) return;
    var windowsToProcess = [], index;
    for (index in windows) {
        if (windows[index] !== window) windowsToProcess.push(windows[index]);
    }
    windowsToProcess.sort(function(w1, w2) { return parseInt(w1.style.zIndex) > parseInt(w2.style.zIndex) ? 1 : -1; });

    windowsToProcess.push(window);

    for (index in windowsToProcess) {
        if (window.className.indexOf('fullscreen') !== -1) continue;
        windowsToProcess[index].style.zIndex = minZindex + parseInt(index);
    }
}

export function getTopVirtualWindow() {
    var maxZIndex = 0,
        topWindow;

    for(var index = 0; index < windows.length; index++) {
        var zIndex = parseInt(windows[index].style.zIndex);

        if (maxZIndex < zIndex) {
            maxZIndex = zIndex;
            topWindow = windows[index];
        }
    }

    return topWindow;
}

export function positionNewVirtualWindow(window, uid) {
    if (browser.mobile) return false;

    var baseClass,
        unmovedClass,
        offsetStepLeft,
        offsetStepTop,
        styleLeft = 262 + 24,// todo: get rid of magic numbers
        styleTop = 0 + 24;

    styleLeft = 0;
    styleTop = 0;

    let defaultStyleLeft = 262 + 24;
    let defaultStyleTop = 0 + 24;

    if (window.className.indexOf("block-mystream") > -1) {
        styleLeft = 680;
        styleTop = 140;
    }

    if (window.className.indexOf("popup-video") > -1) {
        baseClass = "popup-video";
        unmovedClass = VIDEO_WINDOW_UNMOVED_CLASS;
        offsetStepLeft = 24;
        offsetStepTop = 24;
    } else if (window.className.indexOf("popup-pm-window") > -1) {
        baseClass = "popup-pm-window";
        unmovedClass = VIDEO_WINDOW_UNMOVED_CLASS;
        offsetStepLeft = 24;
        offsetStepTop = 24;
    } else return false;

    
    let nStyleLeft = styleLeft;
    let nStyleTop = styleTop;


    var allWindows = document.querySelectorAll(`.${baseClass}`);
    for (var index = 0; index < allWindows.length; index++) {
        if (uid && allWindows[index].uid == uid && allWindows[index].positioned) {
            nStyleLeft = parseInt(allWindows[index].style.left) +  allWindows[index].offsetWidth;
            nStyleTop = parseInt(allWindows[index].style.top);

            if (nStyleLeft > styleLeft) {
                styleLeft = nStyleLeft;
                styleTop = nStyleTop;
            }
            nStyleLeft = 0;
        }
    }

    if (styleLeft == 0) {
        styleLeft = defaultStyleLeft;
        styleTop = defaultStyleTop;
        var unmovedWindows = document.querySelectorAll(`.${baseClass}.${unmovedClass}`);

        for (var index = 0; index < unmovedWindows.length; index++) {
            if (unmovedWindows[index].positioned) {
                styleLeft += offsetStepLeft;
                styleTop += offsetStepTop;
            }
        }
    }
    window.style.left = styleLeft+'px';
    window.style.top = styleTop+'px';
    window.positioned = true;
    if (uid) window.uid = uid;
    // window.className += (' '+untouchedClass);
}

export function onClickGeneric(event) {
    var window = event.currentTarget;
    bringToTop(window);
}

/**
 * A callback for handling dragging start
 *
 * @this Draggabilly
 *
 * @param {Event} event
 * @param {MouseEvent} pointer
 */
export function onDragStart(event, pointer, window) {
    //var window = this.element;
    bringToTop(window);
}

function bringToTop(window) {
    // window.className = window.className.replace(/(untouched-left|untouched-right)/, '');
    window.className = window.className.replace(new RegExp(`(${VIDEO_WINDOW_UNTOUCHED_CLASS}|untouched-right)`), '');

    if (window.className.indexOf('virtual-window') != -1) {
        reorderVirtualWindows(window);
    }
}


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/VirtualWindowManager/index.js